import { Directive, HostListener } from '@angular/core';

@Directive({ selector: '.accordion' })
export class AccordionDirective {
  @HostListener('click', ['$event'])
  onClick(e: Event) {
    const target = e.target as Element;
    const q = target.closest ? target.closest('.accordion-q') : null;
    const item = q ? q.closest('.accordion-item') : null;
    if (!q || !item || !item.parentElement) { return; }

    const isOpen = item.classList.contains('open');
    item.parentElement.querySelectorAll('.accordion-item').forEach(i => {
      i.classList.remove('open');
      const btn = i.querySelector('.accordion-q');
      if (btn) { btn.setAttribute('aria-expanded', 'false'); }
    });
    if (!isOpen) {
      item.classList.add('open');
      q.setAttribute('aria-expanded', 'true');
    }
  }
}
